export default __webpack_public_path__ + "static/media/occupation.9494ebb6.png";